<template>
  <div :class="['modal', { 'is-active': show }]">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Choose Account</p>
        <button class="delete" v-on:click="hide"></button>
      </header>
      <section class="modal-card-body">
        <div class="search-bar is-clearfix mb2">
          <div class="field" style="vertical-align: bottom;">
            <p class="control has-icons-left">
              <input
                class="input search"
                type="search"
                v-model="query"
                placeholder="Search accounts"
                @search="doSearch"
                style="max-width: 100%;"
              />
              <span class="icon is-small is-right">
                <i class="fa fa-search"></i>
              </span>
            </p>
          </div>
        </div>

        <ul class="is-striped" v-if="!searchLoading">
          <li v-for="practice in practices" class="practice-row">
            <article
              class="media pointer"
              v-on:click="switchPractice(practice)"
            >
              <figure class="media-left">
                <div class="image is-64x64">
                  <img :src="practice.attributes.logo" />
                </div>
              </figure>
              <div class="media-content">
                <div class="content">{{ practice.attributes.name }}</div>
              </div>
            </article>
          </li>
        </ul>

        <div v-if="searchLoading" class="mt2">
          <i class="fa fa-refresh fa-spin"></i>
        </div>
      </section>
      <footer class="modal-card-foot">
        <pager :current="currentPage" :total="pageCount" :onClick="doSearch" />
      </footer>
    </div>
  </div>
</template>

<script>
import BaseService from "@/services/BaseService";
import PracticesService from "@/services/PracticesService";
import localStorage from "local-storage";
import pager from "@/components/practice/Pager";
import { setCurrentPractice } from "../helpers/current_practice";

export default {
  name: "practice-switcher",

  components: {
    pager
  },

  data() {
    return {
      query: ""
    };
  },

  computed: {
    show() {
      return this.$store.getters["practice/showSwitcher"];
    },
    practices() {
      return this.$store.getters["practice/sortedList"];
    },
    currentPage() {
      return this.$store.getters["practice/currentPage"];
    },
    pageCount() {
      return this.$store.getters["practice/pageCount"];
    },
    searchQuery() {
      return this.$store.getters["practice/searchQuery"];
    },
    searchLoading() {
      return this.$store.getters["practice/searchLoading"];
    }
  },

  watch: {
    searchQuery() {
      this.query = this.$store.getters["practice/searchQuery"];
    }
  },

  methods: {
    hide() {
      this.$store.dispatch("practice/toggleSwitcher", false);
    },

    switchPractice(practice) {
      const {
        id,
        attributes: { subdomain }
      } = practice;
      setCurrentPractice(practice);
      BaseService.setSubdomain(subdomain);
      this.$store.dispatch("practice/switch", id).then(() => {
        // console.log("subdomain=", subdomain);
        // console.log("this.$route=", this.$route);
        if (this.$route.path == "/practices/list" && subdomain != "public") {
          this.$router.push({ name: "patient-queue-list" });
        } else if (subdomain === "public") {
          this.$router.push({ name: "practice-list" });
        }
        this.hide();
      });
    },
    doSearch(page = 1) {
      this.$store.dispatch("practice/setSearchLoading", true);
      this.$store.dispatch("practice/setSearchQuery", this.query);
      PracticesService.list(this.query, page).then(() => {
        this.$store.dispatch("practice/setSearchLoading", false);
      });
    }
  },

  created() {
    window.bus.$on("practice-switch", practice =>
      this.switchPractice(practice)
    );
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.is-striped {
  li:hover {
    background-color: #fafafa;
  }
}
.modal-card-body {
  min-height: 500px;
  max-height: 500px;
}
.practice-row {
  padding-top: 20px;
  padding-bottom: 20px;
}
.image.is-64x64 {
  height: initial !important;
}
</style>
